import api from './axiosNew';

// ============================================
// Sticky Notes API - matches backend: /api/sticky-notes
// Controller: StickyNoteController.cs
// Service: StickyNoteService.cs
// ============================================

/**
 * Get all sticky notes for the authenticated user
 * GET /api/sticky-notes
 */
export const getStickyNotes = async () => {
  try {
    const response = await api.get('/api/sticky-notes');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch sticky notes:', error);
    return { isSuccess: false, data: [] };
  }
};

/**
 * Create a new sticky note
 * POST /api/sticky-notes
 */
export const createStickyNote = async (data) => {
  try {
    const response = await api.post('/api/sticky-notes', data);
    return response.data;
  } catch (error) {
    console.error('Failed to create sticky note:', error);
    return { isSuccess: false };
  }
};

/**
 * Update a sticky note (auto-save on blur)
 * PUT /api/sticky-notes/:id
 */
export const updateStickyNote = async (id, data) => {
  try {
    const response = await api.put(`/api/sticky-notes/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Failed to update sticky note:', error);
    return { isSuccess: false };
  }
};

/**
 * Delete a sticky note
 * DELETE /api/sticky-notes/:id
 */
export const deleteStickyNote = async (id) => {
  try {
    const response = await api.delete(`/api/sticky-notes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Failed to delete sticky note:', error);
    return { isSuccess: false };
  }
};
